var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgByReport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 0.25C25.4746 0.25 32.75 7.52537 32.75 16.5C32.75 25.4746 25.4746 32.75 16.5 32.75C7.52537 32.75 0.25 25.4746 0.25 16.5C0.25 7.52537 7.52537 0.25 16.5 0.25Z",
    fill: "#0B45DB",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 0.25C25.4746 0.25 32.75 7.52537 32.75 16.5C32.75 25.4746 25.4746 32.75 16.5 32.75C7.52537 32.75 0.25 25.4746 0.25 16.5C0.25 7.52537 7.52537 0.25 16.5 0.25Z",
    stroke: "#0B45DB",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1667 22.5V21.1667C21.1667 20.4594 20.8857 19.7811 20.3856 19.281C19.8855 18.781 19.2073 18.5 18.5 18.5H14.5C13.7928 18.5 13.1145 18.781 12.6144 19.281C12.1143 19.7811 11.8333 20.4594 11.8333 21.1667V22.5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 15.8333C17.9728 15.8333 19.1667 14.6394 19.1667 13.1667C19.1667 11.6939 17.9728 10.5 16.5 10.5C15.0273 10.5 13.8333 11.6939 13.8333 13.1667C13.8333 14.6394 15.0273 15.8333 16.5 15.8333Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgByReport);
export default __webpack_public_path__ + "static/media/by-report.1c642a60c752c70692db22dbb96c6424.svg";
export { ForwardRef as ReactComponent };